import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import i18n from '../../i18n';
import Loading from '../common/Loading';
import SavedSearches from '../../models/Alert';
import User from '../../models/User';
import { fetchUserSavedSearches } from '../../api/SavedSearches';
import { Icon } from '@homeexchange/design';

const PreferredDestinations = ({ user, isLogged }) => {
    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (user && isLogged) {
            setLoading(true);
            fetchUserSavedSearches(user.get ? user.get('id') : user.id)
                .then((searches) => {
                    setDestinations(searches);
                    setLoading(false);
                })
                .catch(() => {
                    setDestinations([]);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [user, isLogged]);

    if (!user || loading) {
        return (
            <>
                <div role="separator" className="divider" />
                <Loading />
            </>
        );
    }

    if (destinations.length > 0) {
        const places = Array.from(
            new Set(
                destinations
                    .filter((desti) => !desti.isOutdated())
                    .filter((desti) => {
                        const destiData = desti.attributes || desti;
                        const placeName = destiData.displayInformation?.title || destiData.place;
                        return typeof placeName === 'string' && placeName.length > 0;
                    })
                    .sort(SavedSearches.sortByDate)
                    .map((dest) => {
                        const destData = dest.attributes || dest;
                        const placeName = destData.displayInformation?.title || destData.place;
                        return placeName.split(',')[0].trim();
                    })
            )
        );

        if (places.length === 0) {
            return null;
        }

        return (
            <>
                <div role="separator" className="divider" />
                <div className="preferred-destinations-info-content">
                    <Icon name="Bell" size="2xl" />
                    <div>
                        <span
                            className="home-preferred-destinations"
                            dangerouslySetInnerHTML={{
                                __html:
                                    places.length <= 3
                                        ? i18n.t('user:user.preferred.destinations', {
                                              first_name: user.get('first_name'),
                                              places: places.join(', '),
                                              count: places.length
                                          })
                                        : i18n.t('user:user.preferred.destinations.andmore', {
                                              first_name: user.get('first_name'),
                                              places: places.slice(0, 3).join(', '),
                                              remaining: Math.max(places.length - 3, 0)
                                          })
                            }}
                        />{' '}
                        <a href={i18n.t('user:user.view.url', { id: user.id })} className="seemore">
                            {i18n.t('common:see_more')}
                        </a>
                    </div>
                </div>
            </>
        );
    }

    return null;
};

PreferredDestinations.propTypes = {
    user: PropTypes.instanceOf(User),
    isLogged: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
    user: state.loadedUsers[ownProps.userId],
    isLogged: Boolean(state.auth.accessToken)
});

export default connect(mapStateToProps)(PreferredDestinations);
